<template>
	<div>
		<div class="row">
    		<div class="col-xl-4 col-md-4 mb-4">
    			<div class="d-flex justify-content-between">
    				<strong>Código:</strong>
    				<span>{{ dados.id }}</span>
    			</div>
    		</div>
			<div class="col-xl-4 col-md-4 mb-4">
    			<div class="d-flex justify-content-between">
    				<strong>Categoria:</strong>
    				<span>{{ dados.categoria }}</span>
    			</div>
    		</div>
    		<div class="col-xl-4 col-md-4 mb-4">
    			<div class="d-flex justify-content-between">
    				<strong>Mostrar no Site:</strong>
    				<span v-if="dados.ativo_site">Sim</span>
    				<span v-else>Não</span>
    			</div>
    		</div>
    	</div>
    	<div class="row">
    		<div class="col-xl-4 col-md-4 mb-4">
    			<div class="d-flex justify-content-between">
    				<strong>Valor:</strong>
    				<span>{{ formatarValor(dados.valor) }}</span>
    			</div>
    		</div>
			<div class="col-xl-4 col-md-4 mb-4">
    			<div class="d-flex justify-content-between">
    				<strong>Custo de produção:</strong>
    				<span>{{ formatarValor(dados.custo_producao) }}</span>
    			</div>
    		</div>
    		<div class="col-xl-4 col-md-4 mb-4">
    			<div class="d-flex justify-content-between">
    				<strong>Percentual de lucro:</strong>
    				<span>{{ formatarPercentual(dados.percentual_lucro) }}</span>
    			</div>
    		</div>
    	</div>
    	<div class="row" v-if="dados.descricao">
    		<div class="col-xl-12 col-md-12 mb-4">
    			<div>
	    			<div>
	    				<strong>Descrição Interna:</strong>
	    			</div>
					<div class="card">
  						<div class="card-body" v-html="dados.descricao"></div>
					</div>
	    		</div>
    		</div>
    	</div>
    	<div class="row" v-if="dados.descricao_site">
    		<div class="col-xl-12 col-md-12 mb-4">
    			<div>
	    			<div>
	    				<strong>Descrição para o Site:</strong>
	    			</div>
					<div class="card">
  						<div class="card-body" v-html="dados.descricao_site"></div>
					</div>
	    		</div>
    		</div>
    	</div>
	</div>
</template>

<script>
	export default {
		props: ['dados'],
		methods: {
			formatarValor(valor) {
				if(valor === null || valor === undefined){
					valor = 0;
				}
				valor = parseFloat(valor);
				return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
			},
			formatarPercentual(percentual) {
				if(percentual === null || percentual === undefined){
					percentual = 0;
				}
				percentual = parseFloat(percentual);
				return percentual.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).replace(/\./g, '') + '%';
			}
		}
	}
</script>